module.exports = __webpack_public_path__ + "img/AddPhoto.ee9d04c2.svg";